module.exports = __webpack_public_path__ + "static/fitnessThree-2d7a4b45539def5f86cac8a24631814c.jpg";